/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, HOME_TODAY_SCREEN, CALENDER_SCREEN, API_CONSTANTS } from '../../global/Constants';
import { HeaderTypes, ActivityType } from "../../global/Enum";
import Moment from 'moment';
import './activity-calendar.css';
import Header from '../common/Header';
import Footer from '../common/Footer';
import ActivityCount from '../common/ActivityCount';
import ActivityItem from '../common/ActivityItem';
import DesktopFooter from '../common/DesktopFooter';
import ApiServices from "../../providers/ApiServices";
import Loader from "../common/loader/Loader";
import Utilities from '../../global/Utilities';
import SyncLoader from '../common/loader/SyncLoader';

class CalendarDayFDOSchedulePage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isPlanned: false,
      selectedDate: new Date(),
      data: {},
      activityData: null,

      // activityData: [
      //   {
      //     id: 1,
      //     fdo_id: "IVF2343",
      //     fdo_title: HOME_TODAY_SCREEN.INDIVIDUAL_VISIT_FARMER,
      //     fdo_desc: "CROP, HYBRID  l  Village",
      //     fdo_review: 1,
      //     fdo_status: "Completed"

      //   },
      //   {
      //     id: 2,
      //     fdo_id: "IVR1557",
      //     fdo_title: HOME_TODAY_SCREEN.INDIVIDUAL_VISIT_RETAILER,
      //     fdo_desc: "CROP, HYBRID  l  Village",
      //     fdo_review: 1,
      //     fdo_status: "Completed"
      //   }
      // ]
    }
  }

  componentDidMount() {
    if (localStorage.getItem(API_CONSTANTS.ACCESS_TOKEN) !== null) {
      let data = null;
      if (this.props.location.state !== undefined) {
        Utilities.LogPrint("Data::::--->", data);
        Utilities.LogPrint("Selected Date::::--->", this.props.location.state.selectedDate);
        data = this.props.location.state.data;
        if (data != null) {
          this.setState({
            data: this.props.location.state.data,
            selectedDate: this.props.location.state.selectedDate
          }, () => {
            this.getUserActivityByDate();
          });


        }

        //this.getActivityByDate(date);
      } else {
        this.props.history.replace(ALL_ROUTES.CALENDAR_ROUTE);
      }
    } else {
      this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
    }
  }


  getFormattedDate() {
    let selectedDate = null;
    if (this.props.location.state !== undefined) {
      selectedDate = this.props.location.state.selectedDate;
      return Moment(selectedDate).format('dddd, DD MMM, yyyy');
    }
  }

  handleToggle = () => {
    this.setState({ isPlanned: !this.state.isPlanned });
  }

  handleSyncLoading = (loading, tableName) => {
    Utilities.LogPrint("handleSyncLoading", loading + tableName);
    this.setState({ isSyncLoading: loading, tableName })
  }

  getUserActivityByDate() {
    const { data, selectedDate } = this.state;
    this.setState({ isLoading: true });
    var request = JSON.stringify({
      date: selectedDate,
      user_id: data?.user_id
    });

    try {
      ApiServices.getUserActivityByDate(request)
        .then(response => {
          Utilities.LogPrint("API_DATA: ---->", response);
          this.setState({ isLoading: false });
          if (response.success) {
            const data = response.data;
            if (data != null) {
              //this.setState({ activityData: data });

              // For Sowing S2S Stage name with Activity
              if (data.completed?.activity?.length > 0) {
                for (let index = 0; index < data.completed?.activity?.length; index++) {
                  const element = data.completed?.activity?.[index];
                  if (element.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                    element.activity_type_name = Utilities.getActivityStageName(element.stage_id);
                  }
                }
              }

              if (data.planned?.activity?.length > 0) {
                for (let index = 0; index < data.planned?.activity?.length; index++) {
                  const element = data.planned?.activity?.[index];
                  if (element.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                    element.activity_type_name = Utilities.getActivityStageName(element.stage_id);
                  }
                }
              }

              this.setState({ activityData: data });

            }
          } else {
            Utilities.LogPrint("Status", response.message);
            if (response.message !== undefined && response.message) {
              this.setState({
                errorMsg: response.message
              });
            }
          }
        }).catch(error => {
          this.setState({ isLoading: false, errorMsg: error });
        });
    } catch (error) {
      this.setState({ isLoading: false, errorMsg: error });
    }
  }

  handleListClick = (item) => {
    const { selectedDate } = this.state;
    item.tehsil_name = this.state.data?.tehsil_name;
    if (item.activity_type_id === ActivityType.INDIVIDUAL_VISIT && item.retailer_id === 0 && item.activity_status_id !== 1) {
      //this.props.history.push(ALL_ROUTES.ACTIVITY_DETAILS_ROUTE);
      this.props.history.push({
        pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
        state: { isFarmer: true, data: item, selectedDate: selectedDate }
      });

    } else if (item.activity_type_id === ActivityType.INDIVIDUAL_VISIT && item.retailer_id !== 0 && item.activity_status_id !== 1) {
      this.props.history.push({
        pathname: ALL_ROUTES.INDIVIDUAL_VISIT_DETAILS_ROUTE,
        state: { isFarmer: false, data: item, selectedDate: selectedDate }
      });

    } else if (item.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION && item.activity_status_id !== 1) {
      //this.props.history.push(ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE);
      this.props.history.push({
        pathname: ALL_ROUTES.SAMPLE_DISTRIBUTION_DETAILS_ROUTE,
        state: { data: item, selectedDate: selectedDate }
      });

    } else if (item.activity_type_id === ActivityType.GROUP_MEETING && item.activity_status_id !== 1) {
      //this.props.history.push(ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE);
      this.props.history.push({
        pathname: ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE,
        state: { data: item, selectedDate: selectedDate }
      });

    } else if (item.activity_type_id === ActivityType.SAMPLE_TO_SALE && item.activity_status_id !== 1) {
      //this.props.history.push(ALL_ROUTES.GROUP_MEETING_DETAILS_ROUTE);

      //item.stageName = "Sowing and Transplantation";
      //item.stageName = "Harvest Details";
      //item.currentStage = 4;
      this.props.history.push({
        pathname: ALL_ROUTES.SAMPLE_TO_SALE_DETAILS_ROUTE,
        state: { data: item, selectedDate: selectedDate }
      });
    }

  }


  handleDelete = (e, item) => {
    Utilities.LogPrint("Item", item);
    var params = JSON.stringify({
      activity_id: item.activity_id,
      is_active: 0
    });
    this.setState({ isLoading: true });
    try {
      ApiServices.deleteActivity(params)
        .then(response => {
          this.setState({ isLoading: false });
          var status = response.success;
          if (status) {
            Utilities.LogPrint("deleteActivity", response.message);
            this.getUserActivityByDate();
          }
          else {
            this.setState({ isLoading: false });
          }
        })
        .catch(error => {
          Utilities.LogPrint("deleteActivity-catch", error);
        });
    }
    catch (error) {
      Utilities.LogPrint("deleteActivity-error", error);
    }
  }

  handleActivitiesEdit = (e, item) => {
    e.preventDefault();
    Utilities.LogPrint("Edit Activity", item);

    this.props.history.push({
      pathname: ALL_ROUTES.ADD_ACTIVITY_ROUTE,
      state: {
        selectedActivity: item.activity_type_name,
        selectedActivityId: item.activity_type_id,
        editActivity: item
      }
    });
  }


  render() {
    const { isLoading, activityData, data, isPlanned, isSyncLoading, tableName } = this.state;

    if (activityData != null) {
      const completed = activityData?.completed;
      const planned = activityData?.planned;


      let startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ --:--";
      let endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ --:--";

      if (activityData?.start_time !== undefined && activityData?.start_time !== null) {
        startTimeStr = HOME_TODAY_SCREEN.DAY_STARTED + " @ " + activityData?.start_time;
      }
      if (activityData?.end_time !== undefined && activityData?.end_time !== null) {
        endTimeStr = HOME_TODAY_SCREEN.DAY_ENDED + " @ " + activityData?.end_time;
      }

      return (
        <div>
          <Header selectedTab={HeaderTypes.CALENDAR} handleSyncLoading={this.handleSyncLoading} />
          <Footer isActive={1} />

          <div className="container pt-35 pb-65">
            <div className="row">
              <div className="col-12">
                <h3 className="title mb-0">{this.getFormattedDate()} Activities for {data?.name}</h3>
                <p className="sub-title">{data?.tehsil_name}</p>
              </div>
            </div>

            {/* Toggle Switch */}
            <div className="row">
              <div className="col-12 d-flex mt-3 align-items-center">
                <label className="ml-auto mr-2 w-25 text-right">Completed</label>
                <label className="toogle-switch">
                  <input type="checkbox" onChange={this.handleToggle} />
                  <span className="slider"></span>
                </label>
                <label className="mr-auto ml-2 w-25">Planned</label>
              </div>
            </div>

            {/* Day Activity Count */}
            {
              !isPlanned ?
                <div className="row mt-3 fod-mobile">
                  <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={completed.IV} />
                  <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={completed.SD} />
                  <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={completed.GM} />
                  <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={completed.S2S} />
                </div> :
                <div className="row mt-3 fod-mobile">
                  <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={planned.IV} />
                  <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={planned.SD} />
                  <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={planned.GM} />
                  <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={planned.S2S} />
                </div>
            }
            {/* <div className="row mt-3 fod-mobile">
              <ActivityCount styleName="count yellow" name={CALENDER_SCREEN.INDIVIDUAL_VISIT} count={completed.IV} />
              <ActivityCount styleName="count brown" name={CALENDER_SCREEN.SAMPLE_DISTRIBUTION} count={completed.SD} />
              <ActivityCount styleName="count blue" name={CALENDER_SCREEN.GROUP_MEET} count={completed.GM} />
              <ActivityCount styleName="count green" name={CALENDER_SCREEN.SAMPLE_TO_SALE} count={completed.S2S} />
            </div> */}

            <div className="row">
              <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                {/* <span className="fod-time">Day Started @ 10:30 am</span> */}
                <span className="fod-time">{startTimeStr}</span>


              </div>
            </div>
            <div className="row">
              <div className="col-12 px-sm-3 px-0">
                {!isPlanned ?
                  this.setActivities(completed) :
                  this.setActivities(planned)
                }

              </div>
            </div>
            <div className="row">
              <div className="col-12 pt-lg-3 pb-lg-0 pt-2 pb-2">
                {/* <span className="fod-time">Day Ended @ 6:00 pm</span> */}
                <span className="fod-time">{endTimeStr}</span>
              </div>
            </div>

          </div>
          <DesktopFooter />
          {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
        </div>
      )
    } else {
      return (
        <div>
          {isLoading ? <Loader /> : null}
        </div>
      );
    }
  }

  setActivities = (data) => {
    return (
      <ul className="fod-list">
        {
          data?.activity.length ?
            data?.activity.map((activityItem, i) => (
              <ActivityItem key={i} activity={activityItem}
                getActivityItem={this.handleListClick}
                handleDelete={this.handleDelete}
                handleActivitiesEdit={this.handleActivitiesEdit}
              />
            )) : null
        }
      </ul>
    )
  }
}

export default withRouter(CalendarDayFDOSchedulePage);